import { useEffect, useRef, useState } from "react";
import Axios from "axios";
import { API_URL } from "../../../config";
import {
  INDISPONIBLE,
  REFUS_LIEN,
  codeRefus,
  verifierLien,
} from "../../../helpers/lienAJeton";

export const ETATS = {
  VERIFICATION: "verification",
  A_CONFIRMER: "a_confirmer",
  ACTIVATION: "activation",
  ACTIVE: "active",
  DEJA_ACTIVE: "deja_active",
  EXPIRE: "expire",
  INVALIDE: "invalide",
  INDISPONIBLE: "indisponible",
};

// Un lien d'activation déjà utilisé veut dire que le compte est activé.
const etatDuRefus = (code) => {
  if (code === REFUS_LIEN.DEJA_UTILISE) return ETATS.DEJA_ACTIVE;
  if (code === REFUS_LIEN.EXPIRE) return ETATS.EXPIRE;
  if (code === INDISPONIBLE) return ETATS.INDISPONIBLE;
  return ETATS.INVALIDE;
};

// Page « Activez votre compte » (lien de l'e-mail d'activation, PER-2509) :
// 1. à l'ouverture, le lien est vérifié sans être consommé ;
// 2. le compte n'est activé qu'au clic sur « Activer mon compte ».
const useActivateAccount = (token) => {
  const [etat, setEtat] = useState(token ? ETATS.VERIFICATION : ETATS.INVALIDE);
  const [echecActivation, setEchecActivation] = useState(false);
  const [essai, setEssai] = useState(0);

  const monte = useRef(true);
  useEffect(() => {
    return () => {
      monte.current = false;
    };
  }, []);

  useEffect(() => {
    if (!token) return undefined;
    let actif = true;
    setEtat(ETATS.VERIFICATION);
    verifierLien(token)
      .then(() => {
        if (actif) setEtat(ETATS.A_CONFIRMER);
      })
      .catch((err) => {
        if (actif) setEtat(etatDuRefus(codeRefus(err)));
      });
    return () => {
      actif = false;
    };
  }, [token, essai]);

  const activer = () => {
    if (etat !== ETATS.A_CONFIRMER) return;
    setEtat(ETATS.ACTIVATION);
    setEchecActivation(false);
    Axios.post(API_URL + "customers/activate-account", { token })
      .then(() => {
        if (monte.current) setEtat(ETATS.ACTIVE);
      })
      .catch((err) => {
        if (!monte.current) return;
        const code = codeRefus(err);
        if (code === INDISPONIBLE) {
          setEtat(ETATS.A_CONFIRMER);
          setEchecActivation(true);
        } else {
          setEtat(etatDuRefus(code));
        }
      });
  };

  const reessayer = () => setEssai((n) => n + 1);

  return { etat, activer, echecActivation, reessayer };
};

export default useActivateAccount;
